import { useMemo, useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import { useUser } from '@gif/shared-rtk';

// Components
import { LoadingSpinner } from '@gif/shared-ui';
import { SEO } from '../..';
import { translate } from '../../../configs';

// Api
import { useGetHubContentQuery } from '../../../api';

// Enums && Types
import { GameIds } from '../../../enums/gameIds';

import { useAppSelector, useAppDispatch } from '../../../store';

const PickleContainer = styled.main`
  height: 100vh;
  width: 100vw;
  iframe {
    border: none;
    display: block;
    overflow: hidden;
  }
`;

const HiddenHeaderOne = styled.h1`
  height: 0;
  margin: 0;
  visibility: hidden;
`;

const PickleLoadingComponent = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  color: lightslategray;
`;

const bootstrapParam = 'bootstrap';
const pageDescription = translate('guessTodaysMysteryMLBPlayer');
const pageTitle = 'MLB Pickle';
const addBootstrapParam = (url: string): string => {
  return url[url.length - 1] === '/'
    ? `${url}${bootstrapParam}`
    : `${url}/${bootstrapParam}`;
};

export const MlbPickle = () => {
  const { user, isLoading: isUserLoading } = useUser({
    useAppSelector,
    useAppDispatch,
  });
  const uid = user.accessToken?.claims?.uid;
  const { data: gamesData, isLoading: isGamesDataLoading } =
    useGetHubContentQuery(
      {
        uid,
      },
      { skip: isUserLoading }
    );
  const pickleGameUrl: string = useMemo(() => {
    const pickleUrl = gamesData?.result?.games.find(
      (game) => game.gameId === GameIds.PICKLE
    )?.uri;
    return pickleUrl ? addBootstrapParam(pickleUrl) : '';
  }, [gamesData]);

  useEffect(() => {
    if (isGamesDataLoading || isUserLoading || pickleGameUrl) {
      return;
    }
    console.error('Mlb Pickle url not provided');
    window.location.href = `${window.location.origin}/play`;
  }, [pickleGameUrl, isGamesDataLoading, isUserLoading]);

  if (isGamesDataLoading || isUserLoading) {
    return (
      <PickleLoadingComponent>
        <LoadingSpinner />
      </PickleLoadingComponent>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
    >
      <PickleContainer>
        <SEO title={pageTitle} description={pageDescription} />
        <HiddenHeaderOne>MLB Pickle</HiddenHeaderOne>
        <iframe
          data-testid="mlbPickle"
          key={bootstrapParam}
          src={pickleGameUrl}
          title="MLB Pickle"
          width="100%"
          height="100%"
        />
      </PickleContainer>
    </motion.div>
  );
};

export default MlbPickle;
